import { useLang } from 'hooks/lang';

import {
  actions,
  isProjectFullBlocked,
  projectStatusByCode,
  taskStatusByCode,
  taskStatusesConfig,
} from 'entities';

import { CircleXIcon } from 'components/Icons';

import { useSingleJustification } from 'providers/Justification';
import { useToast } from 'providers/Toast';
import { useConfirmation } from 'providers/Confirmation';
import { useUser } from 'hooks/user';

import { MESSAGES } from '../../utils';

import { registerTaskOption } from '../options';

export default registerTaskOption({
  Icon: CircleXIcon,

  getLabel: (t) => t('cancel-task'),

  action: 'CANCEL_TASK',

  shortcutKey: 'X',

  useOption: ({ project, updateTask, task }) => {
    const user = useUser();

    const { requestConfirmation } = useConfirmation();
    const { addToast } = useToast();

    const { t } = useLang();

    const statusConfig = taskStatusByCode[task.status];

    const canCancel = [
      project.owner.id === user.id,
      projectStatusByCode[project.status].isStartedStatus,
      statusConfig.canCancel,
      !statusConfig.blocks.fullBlock,
      !isProjectFullBlocked(project.status),
    ].every(Boolean);

    const cancelTask = actions.projects.cancelTask.use({
      onSuccess: () =>
        updateTask({
          status: taskStatusesConfig.canceled.code,
        }),
    });

    const cancel = (): void => addToast(MESSAGES.cancelTaskAborted(t));

    const handleCancelClick = useSingleJustification({
      text: t('what-is-the-reason-for-canceling-this-task'),
      cancel,

      onConfirm: async (justification) =>
        requestConfirmation({
          onConfirm: async () =>
            cancelTask.execute({ justification, project: project.id, task: task.id }),

          cancel,
          type: 'irreversible',
          text: t('the-task-owner-will-be-notified-nad-the-task-will-be-locked-for-any-change'),
          title: `${t('cancel-task')}?`,
        }),
    });

    return {
      action: handleCancelClick,

      loading: cancelTask.loading,

      isEnabled: canCancel,
    };
  },
});
